export default "__VITE_ASSET__BWjAfW0G__"